<template>
  <MfaController
    :componentsUnderControl="componentsUnderControl"
    :errorMessage="errorMessage"
    :factors="factors"
    :form="form"
    :mfaType="mfaType"
    @onError="handleError"
    @onResetErrorMessage="$emit('resetErrorMessage')"
    @onSuccess="handleSuccess"
    :requestKey="requestKey"
    :shouldHideEmailBadge="true"
  />
</template>

<script>
// Components
import DuoUserResetPasswordHandler from 'client/containers/user/UserResetPassword/UserResetPasswordMfaHandlers/DuoUserResetPasswordHandler.vue';
import MfaController from 'client/containers/user/MfaComponents/MfaController.vue';
import PushUserResetPasswordHandler from 'client/containers/user/UserResetPassword/UserResetPasswordMfaHandlers/PushUserResetPasswordHandler.vue';
import TotpUserResetPasswordHandler from 'client/containers/user/UserResetPassword/UserResetPasswordMfaHandlers/TotpUserResetPasswordHandler.vue';
import WebAuthnUserResetPasswordHandler from 'client/containers/user/UserResetPassword/UserResetPasswordMfaHandlers/WebAuthnUserResetPasswordHandler.vue';

// Utils
import ProcessPasswordResetMfaError from 'client/containers/user/MfaComponents/mfaUtils/processPasswordResetMfaError';
import RouteGenerator from 'client/routes/RouteGenerator';

// Constants
import { LoginConsts } from 'client/util/Constants';

const { login } = RouteGenerator;

const { responseMessages } = LoginConsts;
const { passwordResetSuccess } = responseMessages;

export default {
  name: 'UserResetPasswordMfaController',

  components: {
    MfaController,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    factors: {
      type: Array,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    mfaType: {
      type: String,
      required: true,
    },
    requestKey: {
      type: String,
      required: true,
    },
  },

  computed: {
    componentsUnderControl() {
      return [
        {
          id: 'duo',
          componentName: DuoUserResetPasswordHandler.name,
        },
        {
          id: 'push',
          componentName: PushUserResetPasswordHandler.name,
        },
        {
          id: 'totp',
          componentName: TotpUserResetPasswordHandler.name,
        },
        {
          id: 'webauthn',
          componentName: WebAuthnUserResetPasswordHandler.name,
        },
      ];
    },
  },

  methods: {
    handleError(error) {
      const { message, action } = ProcessPasswordResetMfaError(this.mfaType, error);
      if (action === 'exitToLogin') {
        this.handleResetForm();
        this.redirectToLogin(message);
      } else if (action === 'restart') {
        this.handleResetForm();
        this.redirectBackToResetStart(message);
      } else {
        this.$emit('setErrorMessage', message);
      }
    },

    handleResetForm() {
      this.$emit('resetForm');
    },

    handleSuccess() {
      this.$router.push({ name: 'Login', params: { success: passwordResetSuccess } });
    },

    // TODO: the redirect methods should move to the router service when it's created
    redirectBackToResetStart(message) {
      if (message) {
        this.$emit('setErrorMessage', message);
      }
      this.$router.push({
        path: login,
        query: {
          template: 'resetPasswordUserForm',
          key: this.requestKey,
        },
      });
    },
    redirectToLogin(errorMessage) {
      this.$router.push({
        name: 'Login',
        params: { error: errorMessage },
      });
    },
  },
};
</script>
